<template>
  <div>
    <v-layout class="mb-3">
      <v-flex
        xs12
        md6
      >
        <h4
          class="pb-0 display-1 mb-0 mt-0 sz_grafit--text"
          :class="{ required: getMaintenanceExpensesQuestions.other_heating.required }"
        >
          {{ getMaintenanceExpensesQuestions.other_heating.label }}
        </h4>
        <v-textarea
          v-model="otherHeating.type"
          v-validate="{
            ...requiredRegularField(getMaintenanceExpensesQuestions.other_heating.required)
          }"
          :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
          class="pt-0 mb-0 mt-1"
          :error-messages="errors.collect('otherHeatingType')"
          data-vv-name="otherHeatingType"
          data-vv-as=" "
          :disabled="readOnly"
          :rows="1"
          auto-grow
        />
      </v-flex>
    </v-layout>
    <v-layout :wrap="$vuetify.breakpoint.mdAndDown">
      <v-flex
        v-if="getMaintenanceExpensesQuestions.other_heating.hasOwnProperty('tons_per_year')"
        xs12
      >
        <v-layout
          row
          align-center
        >
          <v-flex shrink>
            <CounterButtons
              ref="counter"
              v-model="otherHeating.tonsPerYear"
              v-validate="{
                required: getMaintenanceExpensesQuestions.other_heating.tons_per_year.required
              }"
              class="mr-4 none-growth"
              :error-messages="errors.collect('otherTonsPerYear')"
              data-vv-as=" "
              :data-vv-name="'otherTonsPerYear'"
              :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
              :disabled="disabledCounter || readOnly"
            />
          </v-flex>
          <v-flex
            shrink
            justify-center
            ml-3
          >
            <v-subheader
              :class="{ 'sz_grey--text': disabledCounter }"
              class="px-0 pt-1"
            >
              {{ getMaintenanceExpensesQuestions.other_heating.tons_per_year.label }}
            </v-subheader>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="getMaintenanceExpensesQuestions.other_heating.hasOwnProperty('cost_per_ton')"
        xs12
      >
        <v-layout
          row
          align-center
        >
          <v-flex
            xs12
            md6
          >
            <v-text-field
              v-model="otherHeating.costPerTon"
              v-validate="{
                ...requiredMoney(
                  getMaintenanceExpensesQuestions.other_heating.cost_per_ton.required
                )
              }"
              :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
              :label="getMaintenanceExpensesQuestions.other_heating.cost_per_ton.label"
              :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.ton_price')"
              :error-messages="errors.collect('otherTonPrice')"
              data-vv-name="otherTonPrice"
              inputmode="decimal"
              :disabled="disabledCounter || readOnly"
              @keyup="updateWeightCost"
            />
          </v-flex>
          <v-flex
            shrink
            justify-center
            ml-3
          >
            <v-subheader
              class="px-0 pt-1"
              :class="{ 'sz_grey--text': disabledCounter }"
            >
              PLN
              <span
                v-if="!getMaintenanceExpensesQuestions.other_heating.cost_per_ton.required"
                :class="{ 'sz_grey--text': disabledCounter }"
                class="optional-text ml-1"
              >
                {{ $t('message.optional') | brackets }}</span>
            </v-subheader>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="getMaintenanceExpensesQuestions.other_heating.hasOwnProperty('cost_per_year')"
      class="mb-3 mt-3"
    >
      <v-flex
        xs12
        md6
        lg3
      >
        <v-text-field
          v-model="otherHeating.costPerYear"
          v-validate="{
            ...requiredMoney(getMaintenanceExpensesQuestions.other_heating.cost_per_year.required)
          }"
          :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
          :label="getMaintenanceExpensesQuestions.other_heating.cost_per_year.label"
          :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.price')"
          data-vv-name="otherPerYear"
          inputmode="decimal"
          :error-messages="errors.collect('otherPerYear')"
          :disabled="disabledInput || readOnly"
          @keyup="yearToMonth"
        />
      </v-flex>
      <v-flex
        shrink
        justify-center
        ml-3
      >
        <v-subheader
          class="px-0 pt-1"
          :class="{ 'sz_grey--text': disabledInput }"
        >
          PLN / rok
          <span
            v-if="!getMaintenanceExpensesQuestions.other_heating.cost_per_year.required"
            :class="{ 'sz_grey--text': disabledInput }"
            class="optional-text ml-1"
          >
            {{ $t('message.optional') | brackets }}</span>
        </v-subheader>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="getMaintenanceExpensesQuestions.other_heating.hasOwnProperty('cost_per_month')"
      class="mb-3 mt-3"
    >
      <v-flex
        xs12
        md6
        lg3
      >
        <v-text-field
          v-model="otherHeating.costPerMonth"
          v-validate="{
            ...requiredMoney(getMaintenanceExpensesQuestions.other_heating.cost_per_month.required)
          }"
          :class="{ 'pt-0': $vuetify.breakpoint.lgAndUp }"
          :label="getMaintenanceExpensesQuestions.other_heating.cost_per_month.label"
          :error-messages="errors.collect('otherPrice')"
          :data-vv-as="$t('sheet.sheetOne.meeting.maintenance_expenses.label.price')"
          :data-vv-name="'otherPrice'"
          :disabled="disabledInput || readOnly"
          inputmode="decimal"
          @keyup="updateMonthly"
        />
      </v-flex>
      <v-flex
        shrink
        justify-center
        ml-3
      >
        <v-subheader
          class="px-0 pt-1"
          :class="{
            'sz_grey--text': disabledInput,
            required: getMaintenanceExpensesQuestions.other_heating.cost_per_month.required
          }"
        >
          {{ $t('sheet.sheetOne.meeting.maintenance_expenses.per-month') }}
        </v-subheader>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CounterButtons from '@/components/widgets/sheet/CounterButtons';
import filters from '@/constants/filters';
import formatDecimalVariables from '@/mixins/formatDecimalVariables';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

const { mapFields } = createHelpers({
    getterType: 'sheet/getMaintenanceExpensesField',
    mutationType: 'sheet/updateMaintenanceExpensesField'
});

export default {
    name: 'OtherHeatingForm',
    components: { CounterButtons },
    filters: {
        ...filters
    },
    mixins: [formatDecimalVariables, sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            disabledCounter: false,
            disabledInput: false
        };
    },
    computed: {
        ...mapFields(['otherHeating']),
        ...mapGetters('sheet', ['getMaintenanceExpensesQuestions']),
        weightCost () {
            return (
                this.$options.filters.emptyToZero(
                    this.formatDecimalVariable(this.otherHeating.costPerTon)
                ) * this.otherHeating.tonsPerYear
            );
        },
        perYear () {
            if (isNaN(this.formatDecimalVariable(this.otherHeating.costPerYear))) {
                return 0;
            }
            if (this.otherHeating.costPerYear !== '' || this.otherHeating.costPerYear !== 0) {
                return parseFloat(
                    (this.formatDecimalVariable(this.otherHeating.costPerYear) / 12).toFixed(2)
                );
            } else {
                return 0;
            }
        },
        allCosts () {
            return this.$options.filters.emptyToZero(
                this.formatDecimalVariable(this.otherHeating.costPerMonth)
            );
        }
    },
    watch: {
        'otherHeating.tonsPerYear': {
            immediate: false,
            handler () {
                this.updateWeightCost();
            }
        },
        allCosts: {
            immediate: true,
            handler (val) {
                this.$emit('value', val);
            }
        }
    },
    beforeDestroy () {
        this.otherHeating = {
            type: null,
            tonsPerYear: 0,
            costPerTon: null,
            costPerYear: null,
            costPerMonth: null
        };
    },
    methods: {
        updateWeightCost () {
            this.otherHeating.costPerYear = parseFloat(this.weightCost.toFixed(2));
            this.otherHeating.costPerMonth = this.perYear;
            this.disabledInput = !(
                this.otherHeating.tonsPerYear === 0 &&
        (this.otherHeating.costPerTon === '' || this.otherHeating.costPerTon == null)
            );
        },
        yearToMonth () {
            this.otherHeating.costPerTon = '';
            this.otherHeating.tonsPerYear = 0;
            this.$refs.counter.clear();
            this.otherHeating.costPerMonth = this.perYear;
            this.$validator.validate('otherPrice', this.otherHeating.costPerMonth);

            this.disabledCounter = !(
                (this.otherHeating.costPerMonth === 0 ||
          this.otherHeating.costPerMonth == null ||
          this.otherHeating.costPerMonth === '') &&
        (this.otherHeating.costPerYear == null || this.otherHeating.costPerYear === '')
            );
        },
        updateMonthly () {
            this.otherHeating.costPerTon = '';
            this.otherHeating.tonsPerYear = 0;
            this.$refs.counter.clear();
            this.otherHeating.costPerYear = isNaN(
                this.formatDecimalVariable(this.otherHeating.costPerMonth)
            )
                ? 0
                : parseFloat((this.formatDecimalVariable(this.otherHeating.costPerMonth) * 12).toFixed(2));

            this.$validator.validate('otherPerYear', this.otherHeating.costPerYear);

            this.disabledCounter = !(
                (this.otherHeating.costPerMonth == null || this.otherHeating.costPerMonth === '') &&
        (this.otherHeating.costPerYear == null ||
          this.otherHeating.costPerYear === '' ||
          this.otherHeating.costPerYear === 0)
            );
        }
    }
};
</script>

<style scoped></style>
